module.exports = __webpack_public_path__ + "static/media/BankIdLoading.bd2596dd.jpg";